export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7012.0b9c933f.jpg";